import { Box } from "@mui/material";
import { HookCheckBox } from "../../../../../atoms/form-fields/SLFieldCheckBox";

interface InviteMethodSelectorProps {
  registerState: any;
}

const InviteMethodSelector = ({ registerState }: InviteMethodSelectorProps) => {
  return (
    <Box p={1} display={'flex'} alignItems={'center'} gap={4}>
      <div
        style={{
          marginBottom: 8,
          fontSize: 14,
          color: "rgba(0, 0, 0, 0.6)",
        }}
      >
        Send invite via: *
      </div>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <HookCheckBox
          {...registerState("send_invite.email")}
          label="Email"
          defaultValue={true}
          checkBoxProps={{
            disabled: true,
          }}
          error={{
            value: false,
            message: "At least one method is required"
          }}
        />
        <HookCheckBox
          {...registerState("send_invite.whatsapp")}
          label="WhatsApp"
          checkBoxProps={{
            disabled: true,
          }}
          error={{
            value: false,
            message: "At least one method is required"
          }}
        />
      </Box>
    </Box>
  );
};

export default InviteMethodSelector;